import React from "react";
import { Helmet } from "react-helmet-async";
import { Stack } from "@mui/material";
import V2PageHeader from "../../../../common/V2PageHeader";
import SiteScopeGate from "../../../../common/SiteScopeGate";
import PermissionGate from "../../../../guards/PermissionGate";
import usePermissions from "../../../../../hooks/usePermissions";
import ConfigWAFExceptTabContent from "./components/ConfigWAFExceptTabContent";

const NewServicesWebApplicationExceptions = () => {
  const { getPermissionsForSite, PERMISSIONS } = usePermissions();

  return (
    <PermissionGate permission={PERMISSIONS.WAF_READ} resourceLabel="WAF exceptions">
    <>
      <Helmet title="WAF Exceptions" />
      <Stack spacing={6} sx={{ p: 6 }}>
        <V2PageHeader
          title="WAF Exceptions"
          helpTooltip="Create path-based exceptions that skip WAF inspection for specific URLs, methods, or parameters. Use when a legitimate request pattern would otherwise be blocked."
        />
        <SiteScopeGate mode="single">
          {(siteUid, { selectedSite }) => {
            const canConfigureWAFForSite = selectedSite
              ? getPermissionsForSite(selectedSite).hasPermission(PERMISSIONS.WAF_CONFIGURE)
              : false;
            return (
              <ConfigWAFExceptTabContent siteUid={siteUid} canConfigureWAFForSite={canConfigureWAFForSite} />
            );
          }}
        </SiteScopeGate>
      </Stack>
    </>
    </PermissionGate>
  );
};

export default NewServicesWebApplicationExceptions;
